<template>
<div v-loading="loading">
  <div class="title-h4 title-bar">상관 관계 분석 그래프</div>
  <highcharts v-show="!isEmpty(rscInfoList)" :options="chartOptions" />
</div>
</template>

<script>
import msgUtil from '@/utils/message';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import { heatmapOptions } from '@/constants/chart-options';
import ChartAPI from '@/api/chart/chart-analysis';

/**
 * 상관 관계 분석 화면
 */
export default {
  name: 'WCorrelationAnalysisView',
  props: {
    rscInfoList: {
      type: Array,
    },
  },
  data() {
    return {
      loading: false,
      chartOptions: cloneDeep(heatmapOptions),
    };
  },
  watch: {
    rscInfoList: {
      handler(value) {
        if (isEmpty(value)) {
          this.reset();
        } else {
          this.loadData();
        }
      },
    },
  },
  mounted() {
    this.chartOptions.tooltip = {
      formatter() {
        const point = this.point;
        return `${this.series.xAxis.categories[point.x]}<br>상관계수 : ${point.value}<br>${this.series.yAxis.categories[point.y]}`;
      },
    };
  },
  methods: {
    isEmpty,
    /**
     * 상관분석 차트 데이터를 가져온다.
     * @return {[type]} [description]
     * @author jda
     */
    loadData() {
      this.loading = true;
      ChartAPI.getSmartCorrelationData({
        rscInfoList: this.rscInfoList,
      })
        .then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            const categories = result.category;
            this.chartOptions.xAxis.categories = categories;
            this.chartOptions.yAxis.categories = categories;
            this.chartOptions.series[0].data = result.series;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '상관 분석 정보', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '상관 분석 정보', false));
          throw new Error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 화면을 초기화한다.
     * @author Ju
     */
    reset() {
      this.loading = false;
      this.chartOptions = cloneDeep(heatmapOptions);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/popup/ResourceSmartAnalyzerPopup/CorrelationAnalysisView.vue